/* eslint-disable */

import {atom, selector} from 'recoil';
import Activity from '../types/activities';
import { CategorySetType } from '../utils/categoryConfig';

export const langState = atom({
    key: 'langState',
    default: 'SV' as string,
});

export const setLangState = selector({
  key: 'setLangState',
  get: ({get}) => get(langState),
  set: ({set}, newValue) => {
    set(langState, newValue as string);
  },
});

export const categorySetState = atom({
    key: 'categorySetState',
    default: 'default' as CategorySetType,
});

export const setCategorySetState = selector({
  key: 'setCategorySetState',
  get: ({get}) => get(categorySetState),
  set: ({set}, newValue) => {
    set(categorySetState, newValue as CategorySetType);
  },
});

export const activitiesState = atom({
  key: 'activitiesState',
  default: [] as Activity[],
});

export const setActivitiesState = selector({
  key: 'setActivitiesState',
  get: ({get}) => get(activitiesState),
  set: ({set}, newValue) => {
    set(activitiesState, newValue as Activity[]);
  },
});
